/**
 * Case Mix utility functions
 */

export interface ComorbidityInfo {
  label: string;
  bgClass: string;
}

/**
 * Get comorbidity adjustment label and color based on numeric value
 * @param adjustment - Comorbidity adjustment value (0, 1, or 2)
 * @returns Object with label and background class
 */
export const getComorbidityInfo = (adjustment: number): ComorbidityInfo => {
  switch (adjustment) {
    case 2:
      return {
        label: 'HIGH',
        bgClass: 'bg-red-600',
      };
    case 1:
      return {
        label: 'LOW',
        bgClass: 'bg-amber-500',
      };
    case 0:
      return {
        label: 'NONE',
        bgClass: 'bg-gray-500',
      };
    default:
      return {
        label: String(adjustment),
        bgClass: 'bg-gray-500',
      };
  }
};
